import produce from 'immer';

import {
  ACTIVE_VIOLATIONS_FETCH_FAILURE,
  ACTIVE_VIOLATIONS_FETCH_SUCCESS,
  CLEAR_ACTIVE_VIOLATIONS,
  CLEAR_FREQUENT_VIOLATIONS,
  EDIT_DEFAULT_COMPLY_BY_DAYS_FAILURE,
  EDIT_DEFAULT_COMPLY_BY_DAYS_SUCCESS,
  FETCH_FREQUENT_VIOLATIONS_FAILURE,
  FETCH_FREQUENT_VIOLATIONS_SUCCESS,
  FETCH_VIOLATION_LIST_FAILURE,
  FETCH_VIOLATION_LIST_SUCCESS,
  GET_DEFAULT_COMPLY_BY_DAYS_FAILURE,
  GET_DEFAULT_COMPLY_BY_DAYS_SUCCESS,
  VIOLATION_EDIT_SEQUENCE_FAILURE,
  VIOLATION_EDIT_SEQUENCE_SUCCESS,
  VIOLATION_FETCH_FAILURE,
  VIOLATION_FETCH_REQUEST,
  VIOLATION_FETCH_SUCCESS,
  VIOLATIONS_FETCH_FAILURE,
  VIOLATIONS_FETCH_REQUEST,
  VIOLATIONS_FETCH_SUCCESS,
} from '@actions/violation';

const initialState: IViolationStore = {
  activeViolations: null,
  currentViolation: null,
  violations: null,
  error: null,
  defaultComplyByDays: 7,
  frequentViolations: null,
  violationList: null,
};

export default (state: IViolationStore = initialState, action: any) =>
  produce(state, (draftState: IViolationStore = initialState) => {
    switch (action.type) {
      case VIOLATIONS_FETCH_REQUEST:
        draftState.violations = null;
        draftState.error = null;

        return;

      case VIOLATIONS_FETCH_SUCCESS:
      case VIOLATION_EDIT_SEQUENCE_SUCCESS:
        draftState.violations = action.response;
        draftState.error = null;

        return;

      case VIOLATIONS_FETCH_FAILURE:
        draftState.violations = null;
        draftState.error = action.error;

        return;

      case ACTIVE_VIOLATIONS_FETCH_SUCCESS:
        draftState.activeViolations = action.response;
        draftState.error = null;

        return;

      case ACTIVE_VIOLATIONS_FETCH_FAILURE:
        draftState.activeViolations = null;
        draftState.error = action.error;

        return;

      case VIOLATION_FETCH_REQUEST:
        draftState.currentViolation = null;
        draftState.error = null;

        return;

      case VIOLATION_FETCH_SUCCESS:
        draftState.currentViolation = action.response;
        draftState.error = null;

        return;

      case VIOLATION_FETCH_FAILURE:
        draftState.currentViolation = null;
        draftState.error = action.error;

        return;

      case VIOLATION_EDIT_SEQUENCE_FAILURE:
      case EDIT_DEFAULT_COMPLY_BY_DAYS_FAILURE:
      case GET_DEFAULT_COMPLY_BY_DAYS_FAILURE:
      case FETCH_FREQUENT_VIOLATIONS_FAILURE:
      case FETCH_VIOLATION_LIST_FAILURE:
        draftState.error = action.error;

        return;

      case EDIT_DEFAULT_COMPLY_BY_DAYS_SUCCESS:
      case GET_DEFAULT_COMPLY_BY_DAYS_SUCCESS:
        const { defaultComplyByDays } = action.response;
        draftState.defaultComplyByDays =
          !isNaN(defaultComplyByDays) && defaultComplyByDays >= 0 && defaultComplyByDays <= 365
            ? defaultComplyByDays
            : 7;

        return;

      case FETCH_FREQUENT_VIOLATIONS_SUCCESS:
        draftState.frequentViolations = action.response;
        draftState.error = null;

        return;

      case CLEAR_FREQUENT_VIOLATIONS:
        draftState.frequentViolations = null;

        return;

      case CLEAR_ACTIVE_VIOLATIONS:
        draftState.activeViolations = null;

        return;

      case FETCH_VIOLATION_LIST_SUCCESS:
        draftState.violationList = action.response;

        return;
    }
  });
